import { EDU_API_BASE_URL } from "./env";
import { getAccessToken } from "./session";
import { refreshAccessToken } from "./sso";

const EDU_API_BASE_URL_WITHOUT_TRAILING_SLASH = EDU_API_BASE_URL.replace(/\/+$/, "");
const OPENAPI_CLIENT_BASE_URL = EDU_API_BASE_URL_WITHOUT_TRAILING_SLASH.replace(/\/api$/, "");

async function fetchWithEduAuth(request: Request, accessToken: string | null) {
  const headers = new Headers(request.headers);
  if (accessToken) {
    headers.set("Authorization", `Bearer ${accessToken}`);
  }
  return fetch(new Request(request, {
    credentials: "include",
    headers,
  }));
}

export function getOpenApiClientBaseUrl() {
  return OPENAPI_CLIENT_BASE_URL;
}

export async function apiFetchRequest(request: Request) {
  let response = await fetchWithEduAuth(request.clone(), getAccessToken());
  if (response.status === 401) {
    const refreshedAccessToken = await refreshAccessToken().catch(() => null);
    if (refreshedAccessToken) {
      response = await fetchWithEduAuth(request.clone(), refreshedAccessToken);
    }
  }
  return response;
}
